import Navigation from "../components/Navigation";
import { Footer } from "../components/sections/Footer";
import BlogGrid from "@/components/blog/BlogGrid";
import { blogPosts } from "@/content/blog";

const Blog = () => {
  return (
    <div className="min-h-screen bg-gray-900">
      <Navigation />
      <section className="pt-24 md:pt-32 pb-12 md:pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 text-white">
              Blog
            </h1>
            <p className="text-gray-300 max-w-2xl mx-auto text-lg">
              Insights, tips, and updates from Property Vue
            </p>
          </div>
        </div>
      </section>
      <section className="pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <BlogGrid posts={blogPosts} />
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Blog;
